<template>
  <b-modal id="show-password-modal" ref="show-password-modal" @show="getPassword" @hide="forgetPassword" no-close-on-backdrop ok-only no-stacking>
    <template slot="modal-title"> {{ $t('showPassword') }}</template>
    <p class="text-center">{{ password }}</p>
  </b-modal>
</template>

<script>
  import UserService from '../../services/UserService'

  export default {
    data () {
      return {
        password: null
      }
    },
    methods: {
      getPassword () {
        UserService.getUserPassword(this.$route.params.id)
          .then((response) => {
            this.password = response.data.password
          })
      },
      forgetPassword () {
        this.password = undefined
      }
    }
  }
</script>
